var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-wrapper" },
    [
      !_vm.isapplets
        ? _c(
            "div",
            { staticClass: "header" },
            [
              _c("van-icon", {
                attrs: { name: "arrow-left", size: "20", color: "#fff" },
                on: { click: _vm.goBack }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("video-player", {
        staticClass: "video-player vjs-custom-skin",
        attrs: { options: _vm.playerOptions },
        on: {
          play: function($event) {
            return _vm.onplay($event)
          },
          pause: _vm.onpause,
          ended: _vm.onended
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "video_detail" }, [
        _c("p", { staticClass: "video_name" }, [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _vm.total_length != 0
          ? _c("p", { staticClass: "video_time" }, [
              _vm._v(
                "时长：" + _vm._s(_vm._f("formatSeconds")(_vm.total_length))
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "other_videos" }, [
        _c("p", { staticClass: "other_title" }, [_vm._v("相关视频")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "video_region" },
          _vm._l(_vm.video_list, function(i) {
            return _c(
              "div",
              _vm._l(i.children, function(item) {
                return item.module_type == 2
                  ? _c(
                      "p",
                      {
                        staticClass: "single_video",
                        on: {
                          click: function($event) {
                            return _vm.play_next(item)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "video_pic",
                          attrs: {
                            src: require("../../../static/images/video.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "video_content" }, [
                          _c("span", { staticClass: "other_videos_name" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "video_params" }, [
                            _vm._v("\n                视频\n                "),
                            item.video_time
                              ? _c("span", [
                                  _vm._v(
                                    "| " +
                                      _vm._s(
                                        _vm._f("formatSeconds")(item.video_time)
                                      )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            item.menu_id == _vm.id
                              ? _c("span", { staticClass: "live_sign" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../static/images/living.gif"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v("正在播放\n                ")
                                ])
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              }),
              0
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _vm.zujian_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=2&orderSn=" +
                              this.$route.query.order_id +
                              "&package_id=" +
                              this.$route.query.package_id +
                              "&cid=" +
                              this.$route.query.cid +
                              "&menu_id=" +
                              _vm.menu_id +
                              "&spuID=" +
                              _vm.shopid +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.zujians_flag
        ? _c("div", { staticClass: "class_dialog" }, [
            _c("div", { staticClass: "dialog_box" }, [
              _c("div", { staticClass: "dialog_message" }, [
                _vm._v("手机浏览器暂不支持查看该课件"),
                _c("br"),
                _vm._v('你可在"' + _vm._s(_vm.appname) + '"进行查看')
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { on: { click: _vm.cancel_flag } }, [
                  _vm._v("取消")
                ]),
                _vm._v(" "),
                _vm.android
                  ? _c("span", { staticClass: "goapp" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              _vm.scheme +
                              "?type=2&orderSn=" +
                              this.$route.query.order_id +
                              "&package_id=" +
                              this.$route.query.package_id +
                              "&cid=" +
                              this.$route.query.cid +
                              "&menu_id=" +
                              _vm.menu_id +
                              "&spuID=" +
                              _vm.shopid +
                              "&owner=" +
                              this.$route.query.owner +
                              "&channel=" +
                              this.$route.query.channel +
                              "&orgn=" +
                              this.$route.query.orgn
                          },
                          on: { click: _vm.search_flag }
                        },
                        [_vm._v("打开APP")]
                      )
                    ])
                  : _vm.ios
                  ? _c(
                      "span",
                      { staticClass: "goapp", on: { click: _vm.search_flag } },
                      [_vm._v("去APP查看")]
                    )
                  : _vm._e()
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.ios
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { data: _vm.detail, type: 1 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.applets_flag && _vm.android
        ? _c("popup", {
            staticClass: "popop_content",
            attrs: { type: 2 },
            on: { isopen: _vm.popup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.arshow ? _c("arouse", { on: { arouse: _vm.receive } }) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ace09d44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ace09d44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/index.vue
// module id = null
// module chunks = 